import {
  useSpotlight,
  useSpotlightActionGroups,
  useSpotlightActions,
  useSpotlightActionTypes,
  useSpotlightModes,
  useSpotlightShortcut,
} from '@frontend/hooks/spotlight';
import { useWorkflowUx } from '@frontend/hooks/useWorkflowUx';

import { SPOTLIGHT_GROUPS } from './groups';
import { SPOTLIGHT_MODES } from './modes';
import { SPOTLIGHT_TYPES } from './types';
import { useAskOpalAction } from './useAskOpalAction';
import { useGlobalActions } from './useGlobalActions';

/**
 * Registers the built-in Spotlight commands (settings/theme + navigation) and,
 * only when the `spotlight` feature-flag variable is on, the trigger that makes
 * it reachable — the ref-count enablement and the Cmd/Ctrl+K shortcut. Commands
 * are always registered; the flag gates the trigger, not the catalog. Mounted
 * once in the app shell.
 */
export function SpotlightGlobalCommands() {
  const { spotlight: flagEnabled } = useWorkflowUx();

  // Trigger — gated by the feature flag.
  const { toggle } = useSpotlight(flagEnabled);
  useSpotlightShortcut(flagEnabled, toggle);

  // Catalog — always registered, regardless of the flag.
  useSpotlightActionTypes(SPOTLIGHT_TYPES);
  useSpotlightActionGroups(SPOTLIGHT_GROUPS);
  useSpotlightModes(SPOTLIGHT_MODES);
  useSpotlightActions(useGlobalActions());
  useSpotlightActions(useAskOpalAction());

  return null;
}
